import { ButtonAppearance } from "@/dls/Button";
import { SwitchButton } from "../SwitchButton";

import { IconProps } from "@/types/Icon";

type ExcludedProps = "prefix" | "suffix" | "children";
type ButtonIconProps = React.ComponentProps<typeof SwitchButton>;
type BaseProps = Omit<ButtonIconProps, ExcludedProps>;

enum IconSwitchButtonTheme {
  Primary = "primary",
  Secondary = "secondary",
}

interface Props extends BaseProps {
  iconSize?: number;
  CheckedIcon: React.FC<IconProps>;
  UncheckedIcon: React.FC<IconProps>;
  theme?: IconSwitchButtonTheme;
}

const themes: Record<IconSwitchButtonTheme, BaseProps> = {
  primary: { shouldHaveShadow: true },
  secondary: {
    appearance: ButtonAppearance.Silent,
    shouldRemovePadding: true,
    shouldResizeIcons: false,
  },
};

const IconSwitchButton: React.FC<Props> = ({
  theme = IconSwitchButtonTheme.Secondary,
  iconSize = 24,
  CheckedIcon,
  UncheckedIcon,
  ...rest
}) => {
  return (
    <SwitchButton isIconOnly {...themes[theme]} {...rest}>
      {({ checked }) => {
        const Icon = checked ? CheckedIcon : UncheckedIcon;
        return (
          <>
            <Icon width={iconSize} height={iconSize} />
            <span className="sr-only">Icon</span>
          </>
        );
      }}
    </SwitchButton>
  );
};

export { IconSwitchButton, IconSwitchButtonTheme };
